import { Flag } from "lucide-react";
import { Badge } from "@/components/ui/badge";

/** Red flag for an audit that has had no activity past the configured threshold. */
export function StaleAuditFlag({ idleDays }: { idleDays: number }) {
  return (
    <Badge
      variant="destructive"
      className="ml-2 gap-1 align-middle"
      title={`No activity for ${idleDays} days — this audit needs attention`}
    >
      <Flag className="h-3 w-3" />
      Needs attention
    </Badge>
  );
}
